import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";
import Input from "components/inputs";

const AddressForm = ({
  onFinishAddAddress,
  formRef,
  loading,
  provinces,
  getCities,
  cities,
}) => {
  const { t } = useTranslation();

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <Form
      autoComplete="off"
      className="space-y-1"
      name="address"
      ref={formRef}
      onFinish={onFinishAddAddress}
    >
      <div className="grid grid-cols-2 gap-4">
        <Input
          label={t("card-page.province")}
          inputProps={{
            filterOption,
            showSearch: true,
            role: "presentation",
            autocomplete: "off",
          }}
          name="province"
          required
          type="select"
          selectOptions={provinces}
          onChange={(e) => getCities(e)}
        />

        <Input
          type="select"
          label={t("card-page.city")}
          name="city"
          role="presentation"
          autocomplete="off"
          required
          inputProps={{ filterOption, showSearch: true }}
          selectOptions={cities}
        />
      </div>
      <Input
        type="textArea"
        label={t("card-page.address-content")}
        name="address"
        required
        inputClassName="text-right"
      />
      <div className="grid grid-cols-2 gap-4">
        <Input
          type="tel"
          label={t("card-page.number")}
          name="tel"
          required
          inputProps={{
            type: "number",
            min: 0,
            inputType: "numeric",
            inputMode: "numeric",
          }}
        />
        <Input
          type="tel"
          label={t("unit")}
          name="unit"
          required
          inputProps={{
            type: "number",
            min: 0,
            inputType: "numeric",
            inputMode: "numeric",
          }}
        />
      </div>

      <Input
        type="tel"
        label={t("card-page.postcode")}
        name="postalCode"
        required
        rules={[
          {
            pattern: /^(0[1-9]|[1-9][0-9])\d{8}$/,
            message: t("card-page.validate-post-code"),
          },
        ]}
        inputProps={{
          maxLength: 10,
        }}
      />
      <Button
        loading={loading}
        disabled={loading}
        className={`${
          loading ? "disabled-button-medium" : "primary-button-medium"
        } justify-center items-center !mt-8`}
        block
        htmlType="submit"
      >
        {t("card-page.submit-address")}
      </Button>
    </Form>
  );
};
export default AddressForm;
